import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Guid, Utility } from 'src/app/core/common';

@Directive({
  selector: '[cleanPaste]'
})
/** Cleanup pasted data formatting when pasted in a contenteditable element  */
export class CleanPasteDirective {
  constructor(private element: ElementRef<HTMLElement>) { }

  @Input() cleanPaste: { newLines?: boolean };
  @Output('files-pasted') onFile = new EventEmitter<File[]>();
  ngOnInit() {
    this.element.nativeElement.addEventListener('paste', (event: ClipboardEvent) => {
      event.preventDefault();
      if (event.clipboardData.files?.length)
        this.onFile.emit(Array.from(event.clipboardData.files));
      let text = event.clipboardData.getData('text/plain');
      if (this.cleanPaste.newLines)
        text = text.replace(/\n/g, '<br>');
      document.execCommand('insertHTML', false, text);
    });
  }
}
